export const nbsp = `\u00A0`;
